module.exports = __webpack_public_path__ + "img/DouglasNewman2.4bf0ff00.jpeg";